exports.list = {
    path: '/list_inventory',
    name: 'list_inventory_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/list_inventory/List.vue"),
}
exports.show = {
    path: '/list_inventory/show/:id',
    name: 'list_inventory_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/list_inventory/Show.vue"),
}